module.exports = __webpack_public_path__ + "static/loopdesign-5c9ea210daa30318b0b707084807291f.png";